<template>

    <!-- Page Title
            ============================================= -->
    <section id="page-title">

        <div class="container clearfix">
            <h1>{{ program.programName }}</h1>
            <span>{{ program.typeOfInserted }}</span>
        </div>

    </section><!-- #page-title end -->
    <!-- Content
    ============================================= -->
    <section id="content">
        <div class="content-wrap">
            <div class="container">
            </div>

            <div v-if="program.isPublished == false" class="container clearfix">
                <h2>   {{$t("Program-Details")}} </h2>
            </div>
            <div v-else class="container clearfix">
                <div class="row mt-4 col-mb-50">
                    <div class="col-md-6">
                        <p v-if="program.programDescription == null">

                        </p>
                        <p v-html="program.programDescription" v-else></p>
                        <h3>{{$t("Program-Frequently")}}</h3>
                        <router-link :to="{name:'CommonQuestions'}" class="button button-3d button-mini button-rounded button-dirtygreen">{{$t("Program-FrequentlyAskedQuestions")}}</router-link>
                        <div class="btn-group d-block mt-3 mb-2" role="group">
                            <a :href="program.descFilePath" :download='$t("Program-ProgramJobDescription")' class="btn btn-primary mb-1 ml-5">
                                {{$t("Program-ProgramJobDescription")}}    {{ program.programName }}
                            </a>
                            <a :href="program.approvedSpecialitiesFilePath" :download='$t("Program-AcceptedMajors")' class="btn btn-primary mb-1 ml-5">
                                {{$t("Program-AcceptedMajors")}} {{ program.programName }}
                            </a>
                            <a :href="program.studyPlanFilePath" :download='$t("Program-StudyPlanOfTheProgram")' class="btn btn-primary mb-1 ml-5">​​​​​​{{$t("Program-StudyPlanOfTheProgram")}}</a>
                        </div>
                        <p>
                            {{$t("Program-ApplyForThePrograme")}}
                            <a :href="applicantURL" class="ms-1 fw-bolder text-3" target="_blank">
                                {{$t("Program-ClickHere")}}
                            </a>
                        </p>
                        <p>
                            {{$t("Program-Questions")}}

                            <a :href="contactUsURL" target="_blank" class="ms-1 fw-bolder text-3">
                                {{$t("Program-Communication")}}
                            </a>
                            {{$t("Program-OrUse")}}
                            <a href="#" @click="minzedChat" class="ms-1 fw-bolder text-3">
                                {{$t("Program-InteractiveChat")}}

                            </a>
                        </p>
                        <h4 v-if="program.attachmentList != null && program.attachmentList.length > 0" class="mb-3">{{$t("Program-Attachment")}}</h4>
                        <ol class="list-group list-group-numbered mb-3">
                            <li v-for="(file, index) in program.attachmentList" :key="file.id" class="list-group-item d-flex justify-content-start">
                                <a :download="file.fileName" :href="file.filePath">
                                    <div class="fw-bold">{{file.fileName}}</div>
                                </a>
                            </li>
                        </ol>
                        <h4 class="mb-3" v-if="program.links != null && program.links.length > 0">{{$t("Program-ImportantLinks")}}</h4>
                        <ol class="list-group list-group-numbered mb-3">
                            <li v-for="(link, index) in program.links" :key="link.id" class="list-group-item d-flex justify-content-start">
                                <a target="_blank" :href="link.url">
                                    <div class="fw-bold">{{link.linkText}}</div>
                                </a>
                            </li>
                        </ol>
                        <div v-if="typeId == 1" class="promo promo-dark bg-secondary promo-mini p-5">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h3 class="mb-3">
                                        <i class="fa-solid fa-user-doctor me-2"></i>{{$t("Program-ApplyingApplicant")}}
                                    </h3>
                                    <!--<h4 class="text-white fw-normal">
                                        {{$t("Program-RegistrationPeriod")}}
                                        {{ program.batchExpectedDate }}
                                    </h4>-->
                                </div>
                                <div class="col-12">
                                    <a :href="applicantURL" target="_blank"
                                       class="button button-border button-large fw-normal button-light button-rounded m-0">
                                        {{$t("Program-RegisterNow")}}

                                    </a>
                                </div>
                            </div>
                        </div>
                        <div v-else class="promo promo-dark bg-secondary promo-mini p-5">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h3 class="mb-3" v-if="typeId == 2">
                                        <i class="fa-solid fa-square-h me-2"></i> {{$t("Program-JoinTheProgram")}}
                                        {{$t("Program-AsTrainingCenter")}}
                                    </h3>
                                    <h3 class="mb-3" v-else>
                                        <i class="fa-solid fa-square-h me-2"></i> {{$t("Program-JoinTheProgram")}}
                                        {{$t("Program-AsEmployer")}}
                                    </h3>
                                    <h4 class="text-white fw-normal">
                                      <!--   {{$t("Program-RegistrationPeriod")}}
                                        {{ program.registrationDateCenter }} -->
                                        <p v-html="program.registrationDate"  ></p>
                                  
                                    </h4>
                                </div>
                                <div class="col-12">
                                    <router-link :to="{name:'InterestedPartners', params:{typeId:typeId ,id:programId}}" class="button button-border button-large fw-normal button-light button-rounded m-0">
                                        {{$t("Program-JoinTheProgram")}}
                                    </router-link>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" v-if="program.videoFileList != null && program.videoFileList.length > 0">
                        <div class="row">
                            <div class="col-md-12" v-for="(file, index) in program.videoFileList" :key="file.id">
                                <video width="560" height="315" controls @error="hideVideo">
                                    <source :src="file.filePath">
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section><!-- #content end -->
</template>
<script>
    import * as programService from './Service/ProgramService'
    export default {
        name: 'ProgramTypeComponent',
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                program: null,
                typeId: 0,
                programId: 0,
                contactUsURL: null,
                applicantURL: null
            }
        },
        created() {

            programService.getProgramType(this);
        },
        methods: {
            minzedChat() {
                document.getElementById("minzedChat").click();
            }
        }
        //updated() {
        //    programService.OnCompletedLoadPage();
        //}
    }
</script>
<style>
    .ml-5 {
        margin-left: 5px !important;
    }
</style>